define([
	"dojo/_base/declare",
	"csi/html"
], function(declare,html) {

	return declare(null, {
		// Heading: heading to act on
		heading: null,

		// def.Action: action for editing heading
		action: null,

		// csi.heading.Renderer: heading renderer
		ren: null,

		// Boolean: indicates render action will appear on tooltip
		bTooltip: false,

		// DOMNode: DOMNode to handle onclick event if different than refNode
		//clickNode: null,

		// String: extra CSS class for styling when editable
		//cssEdit: null,


		setClickNode: function(/*DOMNode*/node, /*Boolean?*/bApplyContext) {
			// summary: set node for action
			this.clickNode = node;

			if (node && bApplyContext) {
				html.setElementAction(node, this.heading.getKeyDP());
			}
		}
	});
});